import { render } from "./LiteratureSearchInput.vue?vue&type=template&id=1adfa386"
import script from "./LiteratureSearchInput.vue?vue&type=script&lang=js"
export * from "./LiteratureSearchInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__